import React from "react";
import "./FinalCTA.scss";

const FinalCTA = () => {
  return (
    <section className="finalCtaDreams">
      <div className="container">
        <div className="finalCtaDreams__box">
          <span className="finalCtaDreams__tag">
            Tu gran día comienza aquí
          </span>

          <h2>Empieza hoy a planear la fiesta de tus sueños</h2><hr/>

          <div className="finalCtaDreams__buttons">
            { /*<a
              href="https://dreamsxv.com/catalogo.php"
              target="_blank"
              rel="noreferrer"
              className="finalCtaDreams__btn finalCtaDreams__btn--primary"
            >
              Explorar proveedores
            </a>*/}
           
            <a
              href="https://wa.me/525564426524?text=Me%20interesa%20planear%20mis%20XV%20años"
              target="_blank"
              rel="noreferrer"
              className="finalCtaDreams__btn finalCtaDreams__btn--primary"
            >
              Contáctanos hoy mismo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;